// Shares identical Firestore listeners across screens and keeps them alive briefly
// during route changes / development recompiles. This avoids re-reading the same
// collection every time a component remounts.
const registry = new Map();
const DISCONNECT_GRACE_MS = 30000;

export function subscribeSharedFirestore({ key, start, onData, onError }) {
  let entry = registry.get(key);

  if (!entry) {
    entry = {
      subscribers: new Set(),
      errorSubscribers: new Set(),
      lastData: undefined,
      unsubscribeRemote: null,
      disconnectTimer: null,
    };
    registry.set(key, entry);
  }

  if (entry.disconnectTimer) {
    clearTimeout(entry.disconnectTimer);
    entry.disconnectTimer = null;
  }

  entry.subscribers.add(onData);
  if (onError) entry.errorSubscribers.add(onError);

  if (entry.lastData !== undefined) {
    onData(entry.lastData);
  }

  if (!entry.unsubscribeRemote) {
    entry.unsubscribeRemote = start(
      (data) => {
        entry.lastData = data;
        entry.subscribers.forEach((callback) => callback(data));
      },
      (error) => {
        entry.errorSubscribers.forEach((callback) => callback(error));
      }
    );
  }

  return () => {
    entry.subscribers.delete(onData);
    if (onError) entry.errorSubscribers.delete(onError);

    if (entry.subscribers.size === 0 && !entry.disconnectTimer) {
      entry.disconnectTimer = setTimeout(() => {
        if (entry.subscribers.size === 0) {
          if (entry.unsubscribeRemote) entry.unsubscribeRemote();
          registry.delete(key);
        }
      }, DISCONNECT_GRACE_MS);
    }
  };
}
